import axios from '../axiosConfig';
import { API_BASE_URL } from '../config';

const baseURL = API_BASE_URL; // Not directly used but kept for consistency and future debugging

const authHeaders = () => {
  const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  if (!axios.defaults.headers.common['Authorization']) {
    const token = sessionStorage.getItem('authToken');
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

// Create or update current user's registration for an event
export const registerForEvent = async (eventId, payload) => {
  try {
    const response = await axios.post(`/events/${eventId}/register`, payload, {
      headers: authHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Get current user's registration for an event
export const getMyEventRegistration = async (eventId) => {
  try {
    const response = await axios.get(`/events/${eventId}/registration`, {
      headers: authHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Cancel current user's registration for an event
export const cancelMyEventRegistration = async (eventId) => {
  try {
    const response = await axios.delete(`/events/${eventId}/registration`, {
      headers: authHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// List registrations for an event (employee2/employee3 only)
export const listEventRegistrations = async (eventId) => {
  try {
    const response = await axios.get(`/events/${eventId}/registrations`, {
      headers: authHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

export { baseURL };

